export default function AboutData() {
  return {
    title: "An easy way to protect your greatest asset - your income",
    content:
        "With instant quotes and an easy online application, you can insure your income in case you become too sick or hurt to work.",
  }
}